import React, { Component, Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Nodejs from '../images/svg/nodejs.svg';
import Reactjs from '../images/svg/reactjs.svg';
import GraphQL from '../images/svg/graphql.svg';
import Java from '../images/svg/java.svg';
import Firebase from '../images/svg/firebase.svg';
import MongoDB from '../images/svg/mongodb.svg';
import Expressjs from '../images/svg/expressjs.svg';
import Android from '../images/svg/android.svg';

import NodejsOG from '../images/svg/nodejs-og.svg';
import ReactjsOG from '../images/svg/reactjs-og.svg';
import GraphQLOG from '../images/svg/graphql-og.svg';
import JavaOG from '../images/svg/java-og.svg';
import FirebaseOG from '../images/svg/firebase-og.svg';
import MongoDBOG from '../images/svg/mongodb-og.svg';
import ExpressjsOG from '../images/svg/expressjs-og.svg';
import AndroidOG from '../images/svg/android-og.svg';


const styles = theme => ({
    root: {

    },
    container: {
        width: '90%',
        margin: '70px auto',
    },
    line1: {
        textAlign: 'center',
        fontSize: '40px',
        fontWeight: '400',
        [theme.breakpoints.down('sm')]: {
            fontSize: '30px',
        },
    },
    line2: {
        textAlign: 'center',
        fontSize: '22px',
        margin: '15px 0',
        color: '#708090',
        marginBottom: '50px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '20px',
        },
    },
    technologySection: {
        margin: '20px 0'
    },
    card: {
        border: '1px solid #bcbab8',
        borderRadius: '10px',
        padding: '25px',
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
            padding: '20px'
        },
    },
    technologyImage: {
        width: '100%',
        height: 'auto',
    },
});

class Technology extends Component {
    state = {
        nodejs: Nodejs,
        reactjs: Reactjs,
        graphql: GraphQL,
        java: Java,
        firebase: Firebase,
        mongodb: MongoDB,
        expressjs: Expressjs,
        android: Android
    }
    render() {
        const { classes } = this.props;
        return (
            <Fragment>
                <div className={classes.container}>
                    <Typography variant="h5" className={classes.line1}>We use best <b>technology</b> in the market</Typography>
                    <Typography variant="h5" className={classes.line2}>Helping various businesses to get their idea into reality</Typography>
                    <div className={classes.technologySection}>
                        <Grid container spacing={24}>
                            <Grid item xs={6} sm={3}>
                                <a href="https://nodejs.org/" rel="noopener noreferrer" target="_blank">
                                    <div className={classes.card} onMouseOver={() => {
                                        this.setState({
                                            nodejs: NodejsOG
                                        });
                                    }} onMouseOut={() => {
                                        this.setState({
                                            nodejs: Nodejs
                                        });
                                    }}>
                                        <img src={this.state.nodejs} alt="Nodejs" className={classes.technologyImage} />
                                    </div>
                                </a>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <a href="https://reactjs.org/" rel="noopener noreferrer" target="_blank">
                                    <div className={classes.card} onMouseOver={() => {
                                        this.setState({
                                            reactjs: ReactjsOG
                                        });
                                    }} onMouseOut={() => {
                                        this.setState({
                                            reactjs: Reactjs
                                        });
                                    }}>
                                        <img src={this.state.reactjs} alt="Reactjs" className={classes.technologyImage} />
                                    </div>
                                </a>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <a href="https://graphql.org/" rel="noopener noreferrer" target="_blank">
                                    <div className={classes.card} onMouseOver={() => {
                                        this.setState({
                                            graphql: GraphQLOG
                                        });
                                    }} onMouseOut={() => {
                                        this.setState({
                                            graphql: GraphQL
                                        });
                                    }}>
                                        <img src={this.state.graphql} alt="GraphQL" className={classes.technologyImage} />
                                    </div>
                                </a>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <a href="https://java.com/" rel="noopener noreferrer" target="_blank">
                                    <div className={classes.card} onMouseOver={() => {
                                        this.setState({
                                            java: JavaOG
                                        });
                                    }} onMouseOut={() => {
                                        this.setState({
                                            java: Java
                                        });
                                    }}>
                                        <img src={this.state.java} alt="Java" className={classes.technologyImage} />
                                    </div>
                                </a>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <a href="https://firebase.google.com/" rel="noopener noreferrer" target="_blank">
                                    <div className={classes.card} onMouseOver={() => {
                                        this.setState({
                                            firebase: FirebaseOG
                                        });
                                    }} onMouseOut={() => {
                                        this.setState({
                                            firebase: Firebase
                                        });
                                    }}>
                                        <img src={this.state.firebase} alt="Firebase" className={classes.technologyImage} />
                                    </div>
                                </a>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <a href="https://www.mongodb.com/" rel="noopener noreferrer" target="_blank">
                                    <div className={classes.card} onMouseOver={() => {
                                        this.setState({
                                            mongodb: MongoDBOG
                                        });
                                    }} onMouseOut={() => {
                                        this.setState({
                                            mongodb: MongoDB
                                        });
                                    }}>
                                        <img src={this.state.mongodb} alt="MongoDB" className={classes.technologyImage} />
                                    </div>
                                </a>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <a href="https://www.android.com/" rel="noopener noreferrer" target="_blank">
                                    <div className={classes.card} onMouseOver={() => {
                                        this.setState({
                                            android: AndroidOG
                                        });
                                    }} onMouseOut={() => {
                                        this.setState({
                                            android: Android
                                        });
                                    }}>
                                        <img src={this.state.android} alt="Android" className={classes.technologyImage} />
                                    </div>
                                </a>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <a href="https://expressjs.com/" rel="noopener noreferrer" target="_blank">
                                    <div className={classes.card} onMouseOver={() => {
                                        this.setState({
                                            expressjs: ExpressjsOG
                                        });
                                    }} onMouseOut={() => {
                                        this.setState({
                                            expressjs: Expressjs
                                        });
                                    }}>
                                        <img src={this.state.expressjs} alt="Expressjs" className={classes.technologyImage} />
                                    </div>
                                </a>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </Fragment>
        );
    }
}

Technology.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Technology);